import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetPopularCitiesLoading, EGetPopularCitiesActionTypes } from './types';

export const getPopularCitiesLoading: () => TGetPopularCitiesLoading =
  actionGenerator<EGetPopularCitiesActionTypes.Loading>(EGetPopularCitiesActionTypes.Loading);
